import { HelpResource } from "enums/help-resource";

const HelpResourceTabs: HelpResource[] = [
    HelpResource.Overview,
    HelpResource.HowTo,
    HelpResource.Contributing,
];

export { HelpResourceTabs };
